import { memo } from "react";

export interface CompareAdHocNoteProps {
  /**
   * How many ad hoc rep-added lines are present in the Compare view's scope
   * (see `countAdHocLines`). Zero renders nothing.
   */
  count: number;
}

/**
 * The Compare (price matrix) view's acknowledgement of ad hoc supplier items
 * (KAN-193).
 *
 * Ad hoc lines can never be a row in the cross-supplier price matrix - they
 * have no `product_id` and no offers from any other supplier to compare
 * against, so the matrix (which is built per catalogue product) structurally
 * excludes them. Rather than let the salon wonder where a rep-added item went,
 * this states plainly that they exist, why they aren't comparable, and where to
 * find them (the Cart view, where they render in their own section). Renders
 * nothing when there are none.
 */
export const CompareAdHocNote = memo(function CompareAdHocNote({
  count
}: CompareAdHocNoteProps) {
  if (count <= 0) return null;

  return (
    <p className="mt-3 text-xs text-gray-500" data-testid="compare-ad-hoc-note">
      {count === 1
        ? "1 item added by your SalonStocker rep isn't shown here - a fixed-price item can't be compared across suppliers. See it in the Cart view."
        : `${count} items added by your SalonStocker rep aren't shown here - fixed-price items can't be compared across suppliers. See them in the Cart view.`}
    </p>
  );
});
